import React, { useState } from 'react'
import { createUseStyles } from 'react-jss'
import cn from 'classnames'
import theme from '../style/theme'

const prepTimeOptions = [
  'Under 30 Minutes',
  '30 to 60 Minutes',
  'Over 1 Hour',
  'Im flexible'
]

const SearchBarWithPrepTimeFilter = ({ onFilterChange }) => {
  const classes = useStyles()
  const [prepTime, setPrepTime] = useState('')
  const [searchQuery, setSearchQuery] = useState('')

  const handleFilter = () => {
    const articles = document.querySelectorAll('article')
    let visibleCount = 0

    articles.forEach(article => {
      const articlePrepTime = article.getAttribute('data-meal-prep-time') || ''
      const articleText = article.innerText.toLowerCase()

      const matchesPrepTime = !prepTime || articlePrepTime === prepTime
      const matchesSearch = !searchQuery || articleText.includes(searchQuery.toLowerCase())

      const shouldShow = matchesPrepTime && matchesSearch
      article.style.display = shouldShow ? 'block' : 'none'
      if (shouldShow) visibleCount++
    })
    // Notify parent component about filter results
    if (onFilterChange) {
      onFilterChange({
        hasResults: visibleCount > 0,
        isFiltering: prepTime !== '' || searchQuery !== '',
        resultCount: visibleCount
      })
    }
  }

  const handlePrepTimeChange = (e) => {
    setPrepTime(e.target.value)
  }

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    handleFilter()
  }

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <input
        type='text'
        placeholder='Search by Cut, Flavour or Craving'
        className={cn(classes.input, classes.textInput)}
        value={searchQuery}
        onChange={handleSearchChange}
      />

      <select
        className={cn(classes.input, classes.selectInput)}
        value={prepTime}
        onChange={handlePrepTimeChange}
      >
        <option value=''>Prep time</option>
        {prepTimeOptions.map(option => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>

      <button
        type='submit'
        className={classes.button}
      >
        Search
      </button>
    </form>
  )
}

const useStyles = createUseStyles({
  form: {
    height: '50px',
    display: 'flex',
    gap: '0px',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    maxWidth: 'calc(100% - 9.25rem)',
    margin: '20px auto 50px auto',
    border: '1px solid #38524F',
    padding: '0px',
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '85vw'
      // display: 'grid'
      // gridTemplateColumns: 'repeat(2, 1fr)',
      // gridTemplateRows: 'repeat(2, 1fr)',
      // gridColumnGap: '0px',
      // gridRowGap: '0px'
    },
    '@media (max-width: 1500px)': {
      maxWidth: 'calc(100% - 7rem)'
    },
    '@media (max-width: 1024px)': {
      maxWidth: 'calc(100% - 7rem)'
    },
    '@media (max-width: 600px)': {
      maxWidth: 'calc(100% - 3.75rem)',
      height: '37px'
    }
  },
  input: {
    height: '50px',
    border: 'none',
    padding: '17px',
    borderRadius: '0px',
    fontSize: '14px',
    borderRight: '1px solid #38524F',
    flex: 12,
    backgroundColor: 'transparent',
    '@media (max-width: 1024px)': {
      padding: '10px',
      width: '100%',
      fontSize: '12px',
      gridArea: '1 / 1 / 2 / 3'
    },
    '@media (max-width: 600px)': {
      padding: '18px',
      height: '37px'
    }
  },
  selectInput: {
    display: 'none',
    flex: 3,
    borderRight: '1px solid #38524F',
    borderLeft: '1px solid #38524F',
    borderRadius: '0px',
    backgroundImage: 'url(https://cdn.sanity.io/media-libraries/mlSwrQRRqeyo/images/161b64dd0797007f0fc72aa02f1999e41543b20d-16x16.png)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    paddingLeft: '20px',
    '@media (max-width: 600px)': {
      padding: '18px',
      height: '37px'
    }
  },
  button: {
    height: '50px',
    backgroundColor: 'transparent',
    color: '#38524F',
    padding: '17px 20px',
    border: 'none',
    borderRadius: '0px',
    cursor: 'pointer',
    textAlign: 'center',
    flex: 2,
    '@media (max-width: 1024px)': {
      width: '100%',
      padding: '10px',
      gridArea: '2 / 2 / 3 / 3'
    },
    '@media (max-width: 600px)': {
      height: '37px',
      padding: '10px'
    },
    '&:hover': {
      backgroundColor: '#38524F',
      color: 'white'
    }
  }
}, { name: 'SearchBarWithPrepTimeFilter' })

export default SearchBarWithPrepTimeFilter
